import { render, staticRenderFns } from "./MeuBolao.vue?vue&type=template&id=22ca48da"
import script from "./MeuBolao.vue?vue&type=script&lang=js"
export * from "./MeuBolao.vue?vue&type=script&lang=js"
import style0 from "./MeuBolao.vue?vue&type=style&index=0&id=22ca48da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports